import { render, staticRenderFns } from "./CandidateRemindModal.html?vue&type=template&id=1b5eadfb&scoped=true&external"
import script from "./CandidateRemindModal.js?vue&type=script&lang=js&external"
export * from "./CandidateRemindModal.js?vue&type=script&lang=js&external"
import style0 from "./CandidateRemindModal.scss?vue&type=style&index=0&id=1b5eadfb&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5eadfb",
  null
  
)

export default component.exports